var _defs, _g, _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "148.64000549316407px",
    height: "121.28000183105469px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "175.67999725341798 14.359999084472655 148.64000549316407 121.28000183105469",
    style: {
      background: "rgba(0, 0, 0, 0)"
    },
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "editing-golden",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#806527",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#98f4cc",
    result: "flood-light"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "flood",
    in2: "SourceAlpha",
    result: "flood-comp"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "flood-comp",
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "blur",
    dy: 3,
    result: "offset-blur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "offset-blur",
    result: "comp-blur"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.7,
    intercept: -0.1
  })), /*#__PURE__*/React.createElement("feSpecularLighting", {
    surfaceScale: 200,
    specularConstant: 20,
    specularExponent: 1,
    lightingColor: "#fff",
    in: "blur",
    result: "specular"
  }, /*#__PURE__*/React.createElement("fePointLight", {
    x: -250,
    y: -250,
    z: 3500
  })), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "specular",
    result: "inspecular"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: -1,
    intercept: 1
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "flood-light",
    in2: "inspecular",
    result: "inspecular2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "inspecular2",
    in2: "SourceAlpha",
    result: "light"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "comp-blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "light"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#editing-golden)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(203.15205204486847, 97.39999961853027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.53 0L-0.83 0L10.75-42.24L24.13-42.24L27.07-18.11L38.98-42.24L50.18-42.24L51.33-10.62L51.33-10.62Q51.58-4.35 54.66-2.43L54.66-2.43L54.66-2.43Q53.95-1.15 51.90 0.06L51.90 0.06L51.90 0.06Q49.86 1.28 47.14 1.28L47.14 1.28L47.14 1.28Q44.42 1.28 42.82 0.51L42.82 0.51L42.82 0.51Q41.22-0.26 40.32-1.54L40.32-1.54L40.32-1.54Q38.72-3.84 38.72-8.26L38.72-8.26L38.72-28.03L26.11 0L18.18 0L13.70-28.74L6.53 0ZM82.37-29.57L82.37-29.57L82.37-29.57Q83.33-31.49 83.33-33.28L83.33-33.28L83.33-33.28Q83.33-35.07 83.14-36.06L83.14-36.06L83.14-36.06Q82.94-37.06 82.50-37.82L82.50-37.82L82.50-37.82Q81.54-39.49 79.62-39.49L79.62-39.49L79.62-39.49Q77.25-39.49 75.33-37.76L75.33-37.76L75.33-37.76Q73.28-35.97 73.28-33.15L73.28-33.15L73.28-33.15Q73.28-31.36 74.53-29.98L74.53-29.98L74.53-29.98Q75.78-28.61 77.70-27.33L77.70-27.33L77.70-27.33Q79.62-26.05 81.79-24.77L81.79-24.77L81.79-24.77Q83.97-23.49 85.89-21.95L85.89-21.95L85.89-21.95Q90.30-18.43 90.30-13.70L90.30-13.70L90.30-13.70Q90.30-10.50 88.61-7.78L88.61-7.78L88.61-7.78Q86.91-5.06 84.10-3.07L84.10-3.07L84.10-3.07Q77.95 1.28 69.82 1.28L69.82 1.28L69.82 1.28Q63.23 1.28 59.84-0.86L59.84-0.86L59.84-0.86Q56.45-3.01 56.45-6.27L56.45-6.27L56.45-6.27Q56.45-12.10 60.99-13.57L60.99-13.57L60.99-13.57Q62.27-14.02 64.22-14.02L64.22-14.02L64.22-14.02Q66.18-14.02 68.42-13.18L68.42-13.18L68.42-13.18Q67.39-10.56 67.39-8.19L67.39-8.19L67.39-8.19Q67.39-3.07 71.04-3.07L71.04-3.07L71.04-3.07Q73.41-3.07 75.36-4.80L75.36-4.80L75.36-4.80Q77.31-6.53 77.31-8.48L77.31-8.48L77.31-8.48Q77.31-10.43 76.06-11.84L76.06-11.84L76.06-11.84Q74.82-13.25 72.96-14.37L72.96-14.37L72.96-14.37Q71.10-15.49 68.96-16.58L68.96-16.58L68.96-16.58Q66.82-17.66 64.96-19.20L64.96-19.20L64.96-19.20Q60.61-22.72 60.61-28.35L60.61-28.35L60.61-28.35Q60.61-32 62.40-34.85L62.40-34.85L62.40-34.85Q64.19-37.70 67.07-39.62L67.07-39.62L67.07-39.62Q72.83-43.52 79.90-43.52L79.90-43.52L79.90-43.52Q86.98-43.52 90.40-41.41L90.40-41.41L90.40-41.41Q93.82-39.30 93.82-35.71L93.82-35.71L93.82-35.71Q93.82-32.58 91.39-30.59L91.39-30.59L91.39-30.59Q89.28-28.93 86.72-28.93L86.72-28.93L86.72-28.93Q84.16-28.93 82.37-29.57Z",
    fill: "#2cf09b"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "text {\n  font-size: 64px;\n  font-family: Arial Black;\n  dominant-baseline: central;\n  text-anchor: middle;\n}")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.68b441cf553fc3d755fbf9c3d4cfb7b6.svg";
export { ForwardRef as ReactComponent };